import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import {FaCheck, FaEdit, FaTimes, FaTrash} from "react-icons/fa";
import {ToastContext} from "../App";

export default function MuscleGroups() {
    const [groups, setGroups] = useState([]);
    const [name, setName] = useState("");
    const [editId, setEditId] = useState(null);
    const [editName, setEditName] = useState("");
    const [deleteId, setDeleteId] = useState(null); // لتأكيد الحذف
    const showToast = useContext(ToastContext);

    useEffect(() => {
        fetchGroups();
    }, []);

    const fetchGroups = async () => {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/muscle-groups`);
        setGroups(res.data);
    };

    const addGroup = async () => {
        if (!name.trim()) {
            showToast("اسم المجموعة مطلوب", "danger");
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/muscle-groups`, { name });
            showToast("✅ تم إضافة المجموعة بنجاح", "success");
            setName("");
            fetchGroups();
        } catch (err) {
            showToast("حدث خطأ أثناء إضافة المجموعة", "danger");
        }
    };

    const startEdit = (group) => {
        setEditId(group.id);
        setEditName(group.name);
    };

    const saveEdit = async () => {
        if (!editName.trim()) {
            showToast("اسم المجموعة مطلوب", "danger");
            return;
        }
        await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/muscle-groups/${editId}`, {
            name: editName,
        });
        showToast("✏️ تم تعديل المجموعة بنجاح", "success");
        setEditId(null);
        setEditName("");
        fetchGroups();
    };

    const confirmDelete = (id) => {
        setDeleteId(id);
    };

    const deleteGroup = async () => {
        try {
            await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/muscle-groups/${deleteId}`);
            showToast("🗑️ تم حذف المجموعة بنجاح", "success");
            setDeleteId(null);
            fetchGroups();
        } catch (err) {
            showToast("فشل حذف المجموعة", "danger");
        }
    };

    return (
        <div className={"content"}>
            <div className="container mt-4" dir="rtl">
                <h2 className="mb-4 text-center">مجموعات العضلات</h2>

                {/* إدخال مجموعة جديدة */}
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control text-end"
                        placeholder="أدخل اسم المجموعة"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <button className="btn btn-success mx-2" onClick={addGroup}>
                        إضافة
                    </button>
                </div>

                {/* جدول عرض المجموعات */}
                <div style={{overflowX: "auto", maxHeight: "650px"}}>
                    <table
                        className="table table-hover  table-bordered table-striped shadow rounded text-center align-middle"

                    >
                        <thead style={{backgroundColor: "#1E3A8A", color: "white"}}>
                        <tr>
                            <th style={{width: "10%"}}>#</th>
                            <th>الاسم</th>
                            <th style={{width: "30%"}}>إجراءات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {groups.length > 0 ? (
                            groups.map((g, index) => (
                                <tr
                                    key={g.id}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? "#F3F4F6" : "#FFFFFF",
                                        fontSize: "16px",
                                    }}
                                >
                                    <td>{index + 1}</td>
                                    <td>
                                        {editId === g.id ? (
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                value={editName}
                                                onChange={(e) => setEditName(e.target.value)}
                                            />
                                        ) : (
                                            g.name
                                        )}
                                    </td>
                                    <td>
                                        {editId === g.id ? (
                                            <>
                                                <FaCheck
                                                    style={{cursor: "pointer", color: "green", marginRight: "10px"}}
                                                    size={18}
                                                    title="حفظ"
                                                    onClick={saveEdit}
                                                />
                                                <FaTimes
                                                    style={{cursor: "pointer", color: "gray", marginRight: "10px"}}
                                                    size={18}
                                                    title="إلغاء"
                                                    onClick={() => setEditId(null)}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <FaEdit
                                                    style={{cursor: "pointer", color: "blue", marginRight: "10px"}}
                                                    size={18}
                                                    title="تعديل"
                                                    onClick={() => startEdit(g)}
                                                />
                                                <FaTrash
                                                    style={{cursor: "pointer", color: "red", marginRight: "10px"}}
                                                    size={18}
                                                    title="حذف"
                                                    onClick={() => confirmDelete(g.id)}
                                                />
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3">لا توجد مجموعات</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
                {/* Modal لتأكيد الحذف */}
                {deleteId && (
                    <div
                        className="modal show d-block"
                        tabIndex="-1"
                        style={{background: "rgba(0,0,0,0.5)"}}
                    >
                        <div className="modal-dialog" dir="rtl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">تأكيد الحذف</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setDeleteId(null)}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <p>هل أنت متأكد أنك تريد حذف هذه المجموعة؟</p>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setDeleteId(null)}
                                    >
                                        إلغاء
                                    </button>
                                    <button className="btn btn-danger" onClick={deleteGroup}>
                                        حذف
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>

    );
}
